import { render, staticRenderFns } from "./MoreMenu.vue?vue&type=template&id=8994cb16&"
import script from "./MoreMenu.vue?vue&type=script&lang=js&"
export * from "./MoreMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports